import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchDriveImportRun, startDriveImportRun } from "../api/drive";

const RUN_KEY = ["drive", "import-run"];

// Polls only while a run is in flight, and only while the surface asking
// for it is mounted - the counters are server state, so a closed dialog
// loses nothing by not watching.
export function useDriveImportRun(enabled: boolean) {
  return useQuery({
    queryKey: RUN_KEY,
    queryFn: fetchDriveImportRun,
    enabled,
    refetchInterval: (query) => (query.state.data?.running ? 2500 : false),
    retry: false,
  });
}

export function useStartDriveImportRun() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: RUN_KEY,
    mutationFn: (maxCases: number) => startDriveImportRun(maxCases),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: RUN_KEY }),
  });
}
